// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import React from 'react';
import PictureTwoToneSvg from "@ant-design/icons-svg/es/asn/PictureTwoTone";
import AntdIcon from '../components/AntdIcon';

var PictureTwoTone = function PictureTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PictureTwoToneSvg
  }));
};

PictureTwoTone.displayName = 'PictureTwoTone';
export default React.forwardRef(PictureTwoTone);